import ErrorPage from '@innovyze/stylovyze/lib/components/ErrorPage';
import React, { Component } from 'react';
/**
 * Error boundary for page
 */
class ErrorBoundary extends Component {
    constructor(args) {
        super(args);
        this.state = {
            hasError: false,
            error: new Error(),
            errorInfo: { componentStack: '' },
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
            errorInfo: { componentStack: '' },
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error || new Error(this.props.errorFallbackMessage),
            errorInfo,
        });
    }
    render() {
        const { children } = this.props;
        const { error, hasError } = this.state;
        if (hasError) {
            return React.createElement(ErrorPage, { error: error, resetErrorBoundary: () => { } });
        }
        return children;
    }
}
ErrorBoundary.defaultProps = {
    errorFallbackMessage: 'There was an error loading this page',
};
export default ErrorBoundary;
